/**
 * Created by litao on 2018/10/25.
 */
export default function(redirect) {
  const load = require("./import/_import_" + process.env.NODE_ENV);

  return {
    other: [
      {
        name: "login",
        path: "/login",
        component: load("views/login/index"),
        meta: { permissionCode: "*" },
      },
      {
        name: "error",
        path: "/error/:errorPageRoute?",
        props: true,
        component: load("views/error/index"),
        meta: { permissionCode: "*" },
      },
    ],
    permission: [
      {
        name: "/",
        path: "/",
        component: load("views/layout/index"),
        redirect,
        children: [
          {
            name: "index",
            path: "index",
            component: load("views/index/index"),
            meta: { title: "首页", permissionCode: "index" },
          },
          {
            name: "estate",
            path: "estate",
            component: load("views/estate/index"),
            meta: { title: "物业管理", permissionCode: "estate" },
            redirect,
            children: [
              {
                name: "customer",
                path: "customer",
                component: load("views/estate/customer/index"),
                meta: { title: "业主管理", permissionCode: "customer" },
              },
              {
                name: "xscHouse",
                path: "xscHouse",
                component: load("views/estate/house/index"),
                meta: { title: "房产管理", permissionCode: "xscHouse" },
              },
              {
                name: "tabIndex",
                path: "tabIndex",
                component: load("views/estate/customer/tabIndex"),
                meta: {
                  title: "业主管理详情",
                  permissionCode: "tabIndex",
                  hidden: true,
                },
              },
              {
                name: "mIndex",
                path: "mIndex",
                component: load("views/estate/message/mIndex"),
                meta: {
                  title: "消息管理详情",
                  permissionCode: "mIndex",
                  hidden: true,
                },
              },
              {
                name: "village",
                path: "village",
                component: load("views/estate/village/index"),
                meta: { title: "小区管理", permissionCode: "village" },
              },
              {
                name: "lottery",
                path: "lottery",
                component: load("views/estate/lottery/index"),
                meta: { title: "奖券管理", permissionCode: "lottery" },
              },
              {
                name: "customerSign",
                path: "customerSign",
                component: load("views/estate/customerSign/index"),
                meta: { title: "签约管理", permissionCode: "customerSign" },
              },
              {
                name: "villageContract",
                path: "villageContract",
                component: load("views/estate/villageContract/index"),
                meta: {
                  title: "签约模板管理",
                  permissionCode: "villageContract",
                },
              },
              {
                name: "message",
                path: "message",
                component: load("views/estate/message/list"),
                meta: { title: "消息管理", permissionCode: "message" },
              },
              {
                name: "push",
                path: "push",
                component: load("views/estate/push/list"),
                meta: { title: "推送消息", permissionCode: "push" },
              },
              {
                name: "windowsAccount",
                path: "windowsAccount",
                component: load("views/estate/windowsAccount/list"),
                meta: {
                  title: "新视窗账号管理",
                  permissionCode: "windowsAccount",
                },
              },
              {
                name: "butler",
                path: "butler",
                component: load("views/estate/butler/list"),
                meta: { title: "管家管理", permissionCode: "butler" },
              },
              {
                name: "currentCode",
                path: "currentCode",
                component: load("views/estate/currentCode/list"),
                meta: { title: "访客管理", permissionCode: "currentCode" },
              },
              {
                name: "basicLine",
                path: "basicLine",
                component: load("views/estate/basicLine/list"),
                meta: { title: "条线管理", permissionCode: "basicLine" },
              },
              {
                name: "supervisor",
                path: "supervisor",
                component: load("views/estate/supervisor/list"),
                meta: { title: "主管管理", permissionCode: "supervisor" },
              },
              {
                name: "authCustomer",
                path: "authCustomer",
                component: load("views/estate/customer/authCustomer"),
                meta: { title: "认证业主", permissionCode: "authCustomer" },
              },
              {
                name: "property",
                path: "property",
                component: load("views/system/property/list"),
                meta: { title: "物业管理", permissionCode: "property" },
              },
            ],
          },
          {
            name: "order",
            path: "order",
            component: load("views/order/index"),
            meta: { title: "订单管理", permissionCode: "order" },
            redirect,
            children: [
              {
                name: "repair",
                path: "repair",
                component: load("views/order/repair/index"),
                meta: { title: "报修管理", permissionCode: "repair" },
              },
              {
                name: "complaintNew",
                path: "complaintNew",
                component: load("views/order/complaintNew/index"),
                meta: { title: "投诉建议", permissionCode: "complaintNew" },
              },
              {
                name: "complaint",
                path: "complaint",
                component: load("views/order/complaint/list"),
                meta: { title: "投诉建议", permissionCode: "complaint" },
              },
              {
                name: "sysRepairPersonnel",
                path: "sysRepairPersonnel",
                component: load("views/order/sysRepairPersonnel/list"),
                meta: { title: "工单人员管理", permissionCode: "sysRepairPersonnel" },
              },
              {
                name: "pay",
                path: "pay",
                component: load("views/order/pay/list"),
                meta: { title: "缴费订单", permissionCode: "pay" },
              },
            ],
          },
          {
            name: "activity",
            path: "activity",
            component: load("views/activity/index"),
            meta: { title: "活动管理", permissionCode: "activity" },
            redirect,
            children: [
              {
                name: "activitylist",
                path: "list",
                meta: {
                  title: "活动管理",
                  permissionCode: "activity",
                  icon: "icon-biaodan",
                },
                component: load("views/activity/list"),
              },
              {
                name: "activityRegistration",
                path: "activityRegistration",
                component: load("views/activity/registration/list"),
                meta: {
                  title: "活动报名",
                  permissionCode: "activity",
                  hidden: true,
                },
              },
              {
                name: "activitys",
                path: "activitys",
                component: load("views/paper/activitys/list"),
                meta: {
                  title: "查看问卷",
                  permissionCode: "activity",
                  hidden: true,
                },
              },
              {
                name: "publicImageManage",
                path: "publicImageManage",
                meta: {
                  title: "活动图片",
                  permissionCode: "activity",
                  icon: "icon-biaodan",
                },
                component: load("views/activity/image/list"),
              },
              
              {
                name: "activityUnStatistics",
                path: "activityUnStatistics",
                component: load("views/activity/activityUnStatistics/list"),
                meta: {
                  title: "活动问卷不满意占比",
                  permissionCode: "activity",
                  hidden: true,
                },
              },
              {
                name: "activitySignIn",
                path: "activitySignIn",
                component: load("views/activity/signIn/list"),
                meta: {
                  title: "活动签到",
                  permissionCode: "activity",
                  hidden: true,
                },
              },
              
            ],
          },
          {
            name: "paper",
            path: "paper",
            component: load("views/paper/index"),
            meta: { title: "问卷管理", permissionCode: "paper" },
            redirect,
            children: [
              {
                name: "info",
                path: "info",
                component: load("views/paper/info/index"),
                meta: {
                  title: "问卷管理",
                  permissionCode: "info",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "infoList",
                    path: "infoList",
                    props: true,
                    meta: {
                      title: "问卷管理",
                      permissionCode: "info",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/info/list"),
                  },
                  {
                    name: "infoPage",
                    path: "page/:routeParams?",
                    props: true,
                    meta: {
                      title: "问卷详情",
                      permissionCode: "info",
                      hidden: true,
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/info/page"),
                  },
                ],
              },

              {
                name: "analyze",
                path: "analyze",
                props: true,
                meta: {
                  title: "问卷分析",
                  permissionCode: "analyze",
                  icon: "icon-biaodan",
                },
                component: load("views/paper/analyze/list"),
              },

              {
                name: "bank",
                path: "bank",
                component: load("views/paper/bank/index"),
                meta: {
                  title: "题库管理",
                  permissionCode: "bank",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "bankList",
                    path: "bankList",
                    props: true,
                    meta: {
                      title: "题库列表",
                      permissionCode: "bank",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/bank/list"),
                  },
                  {
                    name: "bankPage",
                    path: "page/:routeParams?",
                    props: true,
                    meta: {
                      title: "题库详情",
                      permissionCode: "bank",
                      hidden: true,
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/bank/page"),
                  },
                ],
              },
              {
                name: "consultation",
                path: "consultation",
                component: load("views/paper/consultation/index"),
                meta: {
                  title: "意见征询",
                  permissionCode: "consultation",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "consultationlist",
                    path: "infoList",
                    props: true,
                    meta: {
                      title: "意见征询",
                      permissionCode: "consultation",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/consultation/list"),
                  },
                  {
                    name: "consultationpage",
                    path: "page/:routeParams?",
                    props: true,
                    meta: {
                      title: "详情",
                      permissionCode: "consultation",
                      hidden: true,
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/consultation/page"),
                  },
                  {
                    name: "infoDetail",
                    path: "infoDetail",
                    component: load("views/paper/consultation/detail"),
                    meta: {
                      title: "答题详情",
                      permissionCode: "consultation",
                      hidden: true,
                    },
                  },
                ],
              },
              {
                name: "satisfaction",
                path: "satisfaction",
                component: load("views/paper/satisfaction/index"),
                meta: {
                  title: "满意度图表",
                  permissionCode: "satisfaction",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "consultationlist",
                    path: "infoList",
                    props: true,
                    meta: {
                      title: "满意度图表",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/satisfaction/list"),
                  },

                  {
                    name: "consultationdetail",
                    path: "consultationdetail",
                    props: true,
                    meta: {
                      title: "满意度详情",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/satisfaction/detail"),
                  },
                  {
                    name: "linedetail",
                    path: "linedetail",
                    props: true,
                    meta: {
                      title: "条线详情",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/satisfaction/linedetail"),
                  },
                  {
                    name: "multipathdetail",
                    path: "multipathdetail",
                    props: true,
                    meta: {
                      title: "多径详情",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/satisfaction/multipathdetail"),
                  },
                ],
              },
              {
                name: "satisfactionScoreTotal",
                path: "satisfactionScoreTotal",
                component: load("views/paper/propertyScoreStatistics/index"),
                meta: {
                  title: "物业整体满意度评价",
                  permissionCode: "propertyScoreStatistics",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "propertyScoreStatistics",
                    path: "propertyScoreStatistics",
                    props: true,
                    meta: {
                      title: "物业整体满意度评价",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/propertyScoreStatistics/list"),
                  },
                ],
              },
              {
                name: "satisfactionScoreTotal",
                path: "satisfactionScoreTotal",
                component: load("views/paper/satisfactionScoreTotal/index"),
                meta: {
                  title: "地产整体满意度评价",
                  permissionCode: "satisfactionScoreTotal",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "satisfactionScoreTotal",
                    path: "satisfactionScoreTotal",
                    props: true,
                    meta: {
                      title: "地产整体满意度评价",
                      permissionCode: "satisfaction",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/satisfactionScoreTotal/list"),
                  },
                ],
              },
              {
                name: "unSatisfactionScoreTotal",
                path: "unSatisfactionScoreTotal",
                component: load("views/paper/unSatisfactionScoreTotal/index"),
                meta: {
                  title: "整体不满意项",
                  permissionCode: "unSatisfactionScoreTotal",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "unSatisfactionScoreTotal",
                    path: "unSatisfactionScoreTotal",
                    props: true,
                    meta: {
                      title: "整体不满意项",
                      permissionCode: "unSatisfactionScoreTotal",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/unSatisfactionScoreTotal/list"),
                  },
                ],
              },


              {
                name: "housekeeper",
                path: "housekeeper",
                component: load("views/paper/satisfaction/housekeeper"),
                meta: {
                  title: "管家列表",
                  permissionCode: "housekeeper",
                  icon: "icon-liebiao",
                },
              },
              {
                name: "precinctInfo",
                path: "precinctInfo",
                props: true,
                meta: {
                  title: "满意度问卷",
                  permissionCode: "precinctInfo",
                  icon: "icon-biaodan",
                },
                component: load("views/paper/precinctInfo/list"),
              },
              {
                name: "noAuthCustomInfo",
                path: "noAuthCustomInfo",
                props: true,
                meta: {
                  title: "未认证用户问卷列表",
                  permissionCode: "noAuthCustomInfo",
                  icon: "icon-biaodan",
                },
                component: load("views/paper/noAuthCustomInfo/list"),
              },
              {
                name: "precinctInfoFour",
                path: "precinctInfoFour",
                props: true,
                meta: {
                  title: "400数据导入页",
                  permissionCode: "precinctInfoFour",
                  icon: "icon-biaodan",
                },
                component: load("views/paper/precinctInfoFour/list"),
              },
              {
                name: "questionnaire",
                path: "questionnaire",
                component: load("views/paper/report/questionnaire"),
                meta: {
                  title: "问卷调查",
                  permissionCode: "questionnaire",
                  icon: "icon-liebiao",
                },
              },{
                name: "paperActivity",
                path: "paperActivity",
                component: load("views/paper/activity/list"),
                meta: {
                  title: "活动问卷",
                  permissionCode: "paperActivity",
                  icon: "icon-liebiao",
                },
                children: [
                  {
                    name: "paperActivityInfo",
                    path: "page/:routeParams?",
                    props: true,
                    meta: {
                      title: "问卷详情",
                      permissionCode: "info",
                      hidden: true,
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/info/page"),
                  },
                ],
              },
              {
                name: "consult",
                path: "consult",
                component: load("views/paper/consult/index"),
                meta: {
                  title: "意见征询单",
                  permissionCode: "consult",
                  icon: "icon-liebiao",
                },
                redirect,
                children: [
                  {
                    name: "consultlist",
                    path: "infoList",
                    props: true,
                    meta: {
                      title: "意见征询单",
                      permissionCode: "consult",
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/consult/list"),
                  },
                  {
                    name: "consultpage",
                    path: "page/:routeParams?",
                    props: true,
                    meta: {
                      title: "详情",
                      permissionCode: "consult",
                      hidden: true,
                      icon: "icon-biaodan",
                    },
                    component: load("views/paper/consult/page"),
                  },
                  {
                    name: "infoDetail",
                    path: "infoDetail",
                    component: load("views/paper/consult/detail"),
                    meta: {
                      title: "答题详情",
                      permissionCode: "consult",
                      hidden: true,
                    },
                  },
                ],
              },
            ],
          },
          {
            name: "community",
            path: "community",
            component: load("views/community/index"),
            meta: { title: "社群管理", permissionCode: "community" },
            redirect,
            children: [
              {
                name: "communityManage",
                path: "communityManage",
                component: load("views/community/communityManage/list"),
                meta: { title: "社群管理", permissionCode: "communityManage" },
              },
              {
                name: "cmTabIndex",
                path: "cmTabIndex",
                component: load("views/community/communityManage/cmTabIndex"),
                meta: {
                  title: "社群管理详情",
                  permissionCode: "cmTabIndex",
                  hidden: true,
                },
              },
              {
                name: "communityPublish",
                path: "communityPublish",
                component: load("views/community/communityPublish/list"),
                meta: { title: "社群发布", permissionCode: "communityPublish" },
              },
              {
                name: "report",
                path: "report",
                component: load("views/community/report/list"),
                meta: { title: "举报管理", permissionCode: "report" },
              },
            ],
          },
          {
            name: "lifeServices",
            path: "lifeServices",
            component: load("views/lifeServices/list"),
            meta: { title: "生活服务", permissionCode: "lifeServices" },
          },
          {
            name: "common",
            path: "common",
            component: load("views/common/list"),
            meta: { title: "公共配置", permissionCode: "common" },
          },
          {
            name: "notice",
            path: "notice",
            component: load("views/notice/list"),
            meta: { title: "公告管理", permissionCode: "notice" },
          },
          {
            name: "merchant",
            path: "merchant",
            component: load("views/merchants/index"),
            meta: { title: "商家管理", permissionCode: "merchant" },
            redirect,
            children: [
              {
                name: "merchants",
                path: "merchants",
                component: load("views/merchants/list"),
                meta: {
                  title: "商家管理",
                  permissionCode: "merchants",
                  hidden: true,
                },
              },
              {
                name: "merchantsTab",
                path: "merchantsTab",
                component: load("views/merchants/merchantsTab"),
                meta: {
                  title: "商家管理详情",
                  permissionCode: "merchantsTab",
                  hidden: true,
                },
              },
            ],
          },
          {
            name: "merchantActivity",
            path: "merchantActivity",
            component: load("views/merchantActivity/list"),
            meta: { title: "商家活动", permissionCode: "merchantActivity" },
          },
          {
            name: "award",
            path: "award",
            component: load("views/award/index"),
            meta: { title: "抽奖管理", permissionCode: "award" },
            redirect,
            children: [
              {
                name: "prize",
                path: "prize",
                component: load("views/award/prize/index"),
                meta: { title: "奖品管理", permissionCode: "prize" },
              },
              {
                name: "winPrize",
                path: "winPrize",
                component: load("views/award/winPrize/index"),
                meta: { title: "中奖管理", permissionCode: "winPrize" },
              },
              {
                name: "lotteryVillage",
                path: "lotteryVillage",
                component: load("views/estate/lottery/village/index"),
                meta: { title: "抽奖管理", permissionCode: "lotteryVillage" },
              },
            ],
          },
          {
            name: "active",
            path: "active",
            component: load("views/active/index"),
            meta: { title: "活跃度管理", permissionCode: "active" },
            redirect,
            children: [
              {
                name: "customerData",
                path: "customerData",
                component: load("views/active/customerData/index"),
                meta: { title: "用户数据", permissionCode: "customerData" },
              },
              {
                name: "dimension",
                path: "dimension",
                component: load("views/active/dimension/index"),
                meta: { title: "小区维度", permissionCode: "dimension" },
              },
            ],
          },
          {
            name: "integral",
            path: "integral",
            component: load("views/integral/index"),
            meta: { title: "积分管理", permissionCode: "integral" },
            redirect,
            children: [
              {
                name: "integralRule",
                path: "integralRule",
                component: load("views/integral/integralRule/index"),
                meta: { title: "积分规则", permissionCode: "integralRule" },
              },
              {
                name: "deductPoint",
                path: "deductPoint",
                component: load("views/integral/deductPoint/index"),
                meta: { title: "积分抵扣", permissionCode: "deductPoint" },
              },
              {
                name: "cstIntegral",
                path: "cstIntegral",
                component: load("views/integral/cstIntegral/index"),
                meta: { title: "用户积分", permissionCode: "cstIntegral" },
              },
            ],
          },
          {
            name: "copywriting",
            path: "copywriting",
            component: load("views/copywriting/index"),
            meta: { title: "文案管理", permissionCode: "copywriting" },
            redirect,
            children: [
              {
                name: "tag",
                path: "tag",
                component: load("views/copywriting/tag/index"),
                meta: { title: "标签", permissionCode: "tag" },
              },
              {
                name: "template",
                path: "template",
                component: load("views/copywriting/template/index"),
                meta: { title: "文案模板", permissionCode: "template" },
              },
              {
                name: "argument",
                path: "argument",
                component: load("views/copywriting/argument/index"),
                meta: { title: "文案参数", permissionCode: "argument" },
              },
              {
                name: "image",
                path: "image",
                component: load("views/copywriting/image/list"),
                meta: { title: "背景图片", permissionCode: "image" },
              },
              {
                name: "chatlet",
                path: "chatlet",
                component: load("views/copywriting/chatlet/list"),
                meta: { title: "公共贴图", permissionCode: "chatlet" },
              },
              {
                name: "butlerLog",
                path: "butlerLog",
                component: load("views/copywriting/log/list"),
                meta: { title: "操作历史", permissionCode: "butlerLog" },
              },
              {
                name: "knowledgeCate",
                path: "knowledgeCate",
                component: load("views/knowledge/cate/list"),
                meta: { title: "知识库分类管理", permissionCode: "knowledgeCate" },
              },{
                name: "knowledge",
                path: "knowledge",
                component: load("views/knowledge/list"),
                meta: { title: "知识库管理", permissionCode: "knowledge" },
              },{
                name: "knowledgeButler",
                path: "knowledgeButler",
                component: load("views/knowledge/butler/list"),
                meta: { title: "知识库", permissionCode: "knowledgeButler" },
              }, {
                name: "publicityCate",
                path: "publicityCate",
                component: load("views/publicity/cate/list"),
                meta: { title: "宣传图分类管理", permissionCode: "publicityCate" },
              }, {
                name: "publicityImg",
                path: "publicityImg",
                component: load("views/publicity/img/index"),
                meta: { title: "宣传图管理", permissionCode: "publicityImg" },
              },
            ],
          },
          {
            name: "system",
            path: "system",
            component: load("views/system/index"),
            meta: { title: "系统设置", permissionCode: "system" },
            redirect,
            children: [
              {
                name: "dict",
                path: "dict",
                component: load("views/system/dict/index"),
                meta: { title: "字典管理", permissionCode: "dict" },
              },
              {
                name: "role",
                path: "role",
                component: load("views/system/role/index"),
                meta: { title: "角色管理", permissionCode: "role" },
              },
              {
                name: "resource",
                path: "resource",
                component: load("views/system/resource/index"),
                meta: { title: "菜单管理", permissionCode: "resource" },
              },
              {
                name: "account",
                path: "account",
                component: load("views/system/account/index"),
                meta: { title: "账户管理", permissionCode: "account" },
              },
              {
                name: "version",
                path: "version",
                component: load("views/system/version/list"),
                meta: { title: "app版本管理", permissionCode: "version" },
              },
              {
                name: "banner",
                path: "banner",
                component: load("views/system/banner/list"),
                meta: { title: "banner图管理", permissionCode: "banner" },
              },
              {
                name: "qdbanner",
                path: "qdbanner",
                component: load("views/system/qdbanner/list"),
                meta: { title: "青岛banner图管理", permissionCode: "qdbanner" },
              },
              {
                name: "opinion",
                path: "opinion",
                component: load("views/system/opinion/list"),
                meta: { title: "意见反馈", permissionCode: "opinion" },
              },
              {
                name: "homeSetting",
                path: "homeSetting",
                component: load("views/system/home/index"),
                meta: { title: "首页设置", permissionCode: "homeSetting" },
              },
              {
                name: "operationLog",
                path: "operationLog",
                component: load("views/system/operationLog/list"),
                meta: { title: "日志管理", permissionCode: "operationLog" },
              },
              {
                name: "server",
                path: "server",
                component: load("views/system/monitor/server/index"),
                meta: { title: "服务监控", permissionCode: "server" },
              },
              {
                name: "cache",
                path: "cache",
                component: load("views/system/monitor/cache/index"),
                meta: { title: "缓存监控", permissionCode: "cache" },
              },
              {
                name: "delCodeNum",
                path: "delCodeNum",
                component: load("views/system/monitor/redis/index"),
                meta: { title: "清除数据", permissionCode: "delCodeNum" },
              },
              {
                name: "groupRepairPerson",
                path: "groupRepairPerson",
                component: load("views/order/groupRepairPerson/index"),
                meta: { title: "集团工单人员配置", permissionCode: "groupRepairPerson" },
              },
            ],
          },
          {
            name: "evaluate",
            path: "evaluate",
            component: load("views/evaluate/index"),
            meta: { title: "服务评价", permissionCode: "evaluate" },
            redirect,
            children: [
              {
                name: "evaluateList",
                path: "evaluateList",
                component: load("views/evaluate/list"),
                meta: { title: "评价列表", permissionCode: "evaluateList" },
              },
              {
                name: "pennant",
                path: "pennant",
                component: load("views/evaluate/pennant/index"),
                meta: { title: "锦旗", permissionCode: "pennant" },
              },
              {
                name: "pennantUser",
                path: "pennantUser",
                component: load("views/evaluate/butlerPennant/list"),
                meta: { title: "赠送锦旗", permissionCode: "pennantUser" },
              },
            ]
          }
        ],
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/configure/router/routerTable.js